import React from 'react';

const navigator = (e, action, student, handleClose) => {
    e.preventDefault();
    window.parent.postMessage({ eventName: 'modalDeleteMessage', value: { ...action, studentId: student.id } }, '*');
};

export default ({ action, domain, student }) => {
    return (
        <a
            onClick={(e) => {
                navigator(e, action, student);
            }}
            href={`#`}
        >
            {action.label}
        </a>
    );
};
